import { axiosAiq } from 'config';
import { SLACK_SEND_REQUEST_TIMEOUT_MS } from 'utils/slackMessages';

export const getAvailableSlackMessages = async (transactionId) => {
    const response = await axiosAiq.get(`/transactions/trucks/${transactionId}/slack-messages`);
    return response.data;
};

// Async: the backend only accepts the request and answers { id, status: 'PENDING' }. The final result arrives later as a
// .SlackSendResultMessage on the desk websocket, matched by log_id === id. A timeout has no response, so the saga ends
// it as UNKNOWN ("may have been delivered") and the Agent can retry (see SLACK_SEND_REQUEST_TIMEOUT_MS).
export const sendSlackMessage = async (transactionId, request) => {
    const response = await axiosAiq.post(`/transactions/trucks/${transactionId}/slack-messages/send`, request, {
        timeout: SLACK_SEND_REQUEST_TIMEOUT_MS,
    });
    return response.data;
};
